__turbopack_context__.v({
  "count-label": "menu-module-scss-module__FsIWLq__count-label",
  "menu-button": "menu-module-scss-module__FsIWLq__menu-button",
  "menu-wrapper": "menu-module-scss-module__FsIWLq__menu-wrapper",
});
